import { render, staticRenderFns } from "./Lives.vue?vue&type=template&id=1eb24315&scoped=true"
import script from "./Lives.vue?vue&type=script&lang=js"
export * from "./Lives.vue?vue&type=script&lang=js"
import style0 from "./Lives.vue?vue&type=style&index=0&id=1eb24315&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb24315",
  null
  
)

export default component.exports